import React from 'react';

/**
 * IB-755 — Budget Versions v2.
 *
 * Re-bases the whole versions list's movement figures. Default is "Previous
 * version" (each row compares to its own immediately-preceding version); any
 * specific version can be selected as the fixed reference every row (and the
 * hero comparison tile) is measured against. Selection lives in the parent so a
 * change re-bases instantly with no reload.
 *
 * `mode` is either the literal 'prior' or a version id (as a string). `versions`
 * is the list of selectable versions ({ id, version, name }), ordered by the
 * caller.
 */
export const COMPARISON_MODE_PRIOR = 'prior';

export default function ComparisonSelector({ versions = [], mode, onChange }) {
    return (
        <div className="tw-flex tw-items-center tw-gap-x-2">
            <label htmlFor="version-comparison" className="tw-whitespace-nowrap tw-text-sm tw-text-charcoal-75 tw-font-medium">
                {$t('Compare against')}
            </label>
            <select id="version-comparison" className="select-input tw-w-auto !tw-h-10" value={mode} onChange={(e) => onChange(e.target.value)}>
                <option value={COMPARISON_MODE_PRIOR}>{$t('Previous version')}</option>
                {versions.map((version) => (
                    <option key={version.id} value={String(version.id)}>
                        {version.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
